import { apiFetch } from './client.js';

/** A live business client's declared activity (DEV-92). */

export interface DeclaredValue {
  path: string;
  label: string;
  kind: 'amount' | 'count' | 'text' | 'choice';
  options?: { value: string; label: string }[];
  value: string;
}

export interface DeclaredHistoryEntry {
  id: string;
  path: string;
  label: string;
  before: string;
  after: string;
  reason: string;
  by: string;
  byName: string | null;
  at: string;
  kind: string | null;
}

export interface DeclaredInformation {
  applicationId: string;
  accountType: string;
  status: string;
  updatable: boolean;
  fields: DeclaredValue[];
  asDecided: DeclaredValue[] | null;
  history: DeclaredHistoryEntry[];
}

export const declaredApi = {
  get: (customerId: string): Promise<DeclaredInformation> =>
    apiFetch(`/admin/customers/${customerId}/declared-information`),

  /** Update what a live client declared. Only changed fields are sent. */
  update: (applicationId: string, changes: { path: string; value: string }[], reason: string): Promise<{ changed: string[] }> =>
    apiFetch(`/admin/onboarding/applications/${applicationId}/declared`, { method: 'POST', body: { changes, reason } }),
};
